import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GuardFeature } from "../../blocks/guard-feature";
import { HomeAPI } from "../../blocks/home-api";
import { HomeBanner } from "../../blocks/home-banner";
import { HomeCertification } from "../../blocks/home-certification";
import { HomeManagement } from "../../blocks/home-management";
import { HomeTryOn } from "../../blocks/home-try-on";
import { PrivateCloudQuestion } from "../../blocks/private-cloud-question";
import { SolutionCustomer } from "../../blocks/solution-customer";
import { SSOPageContent } from "../../blocks/ssoPage-content";
import { Header } from "../../components/Header";
import { Link } from "../../components/LinkIcon";
import "./styles.less";

export const HelloPage = () => {
  const { t, i18n } = useTranslation();
  const [showCode, setShowCode] = useState(false);
  useEffect(() => {
    i18n.changeLanguage("zh-CN");
  }, [i18n]);
  return (
    <div className="hello-page">
      <div
        style={{
          width: 1200,
          margin: "24px auto 40px auto",
        }}
      >
        <div className="logo" style={{ cursor: "unset" }}>
          <img
            src="//files.authing.co/authing-website/authing-logo-new.svg"
            alt=""
          />
        </div>
      </div>

      <HomeBanner
        tipOne="3000 次免费 API 调用次数"
        title="开发更快、登录更安全的身份解决方案"
        description="Authing 身份云向企业及开发者提供安全可靠、体验绝佳的登录认证和授权服务，开发速度远超传统 IAM，而成本仅是其 1/10。"
        bannerImg="//files.authing.co/authing-website/guard-framework-img.png"
        actions={
          <>
            <a
              href="https://vue-authing.authing.cn/"
              // eslint-disable-next-line react/jsx-no-target-blank
              target="_blank"
              className="try-now-link-btn"
            >
              立即使用
            </a>

            <span style={{ marginLeft: 30 }}>
              <Link
                target="_blank"
                href="https://docs.authing.cn/v2/quickstarts/spa/vue.html"
              >
                开发者文档
              </Link>
            </span>
          </>
        }
      />

      <HomeAPI
        dataRows={[
          {
            count: "1000+",
            text: "即需即用的 SDK",
          },
          {
            count: "99.99%",
            text: "可用性和稳定性",
          },
          {
            count: "+500%",
            text: "IT 集成速率",
          },
          {
            count: "-50%",
            text: "开发工时",
          },
        ]}
        vueLink="https://docs.authing.cn/v2/quickstarts/spa/vue.html#"
      />

      <GuardFeature
        btnLinks={[
          {
            text: "开发者文档",
            link: "https://docs.authing.cn/v2/reference/ui-components/",
          },
          {
            text: "开发者文档",
            link: "https://docs.authing.cn/v2/reference/ui-components/",
          },
          {
            text: "开发者文档",
            link: "https://docs.authing.cn/v2/reference/ui-components/",
          },
          {
            text: "开发者文档",
            link: "https://docs.authing.cn/v2/reference/ui-components/",
          },
        ]}
        subTitle={
          <div className="guard-sub-title">
            通用登录组件（Guard）帮助开发者屏蔽了很多底层认证的实现细节，同时也包括繁琐的
            UI 开发。使得企业和开发者可以快速上线安全的、跨平台的、自定义 UI
            的统一登录表单。
          </div>
        }
        title={
          <div
            style={{
              fontSize: 32,
            }}
          >
            通用登录组件：免去繁琐设计，帮助开发者快速上线
          </div>
        }
      />

      <SSOPageContent
        docsText="开发者文档"
        docsLink="https://docs.authing.cn/v2/concepts/user-pool.html#%E7%AE%A1%E7%90%86%E5%91%98%E6%8E%A7%E5%88%B6%E5%8F%B0"
        title="单点登录：一次登录，轻松访问所有应用"
        subTitle="Authing 凭借单点登录技术，实现成员、客户在一处访问任何软件服务，并统一管控身份权限。无论通过企业联合、社会登录还是用户名和密码身份验证，都能够用户只需登录一次，就可以使用他们被授予访问权限的所有应用。"
      />

      <HomeManagement
        noToggleBtn
        tryNowBtn={
          <Link target="_blank" href="https://vue-authing.authing.cn/">
            立即使用
          </Link>
        }
      />

      <SolutionCustomer />

      <HomeCertification />

      <PrivateCloudQuestion
        title="开发者使用指南"
        questions={[
          {
            title: "Vue 快速开始",
            detail: [
              <>
                你可以使用 Authing 快速为新开发的或已有的 Vue 应用集成认证能力。
                <a
                  href="https://docs.authing.cn/v2/quickstarts/spa/vue.html#"
                  // eslint-disable-next-line react/jsx-no-target-blank
                  target="_blank"
                >
                  本教程讲述如何使用 Authing SDK 为你的 Vue 应用添加认证能力。
                </a>
              </>,
            ],
          },
          {
            title: "使用 API & SDK 完成认证",
            detail: [
              <>
                Authing 提供 RESTful、 GraphQL 两种形式的 HTTP
                API，以及十余种不同语言和框架的 SDK。你可以基于这些{" "}
                <a
                  href="https://docs.authing.cn/v2/guides/basics/authenticate-first-user/use-api-sdk/"
                  // eslint-disable-next-line react/jsx-no-target-blank
                  target="_blank"
                >
                  API & SDK 资源
                </a>
                ，灵活得组合出你需要的认证流程。
              </>,
            ],
          },
          {
            title: "验证用户身份凭证（token）",
            detail: [
              <>
                当你的用户成功登录后，Authing 会为该用户签发一个{" "}
                <a
                  href="https://docs.authing.cn/v2/concepts/id-token.html"
                  // eslint-disable-next-line react/jsx-no-target-blank
                  target="_blank"
                >
                  OIDC IdToken
                </a>
                作为身份凭证。验证方式请查看
                <a
                  href="https://docs.authing.cn/v2/guides/faqs/how-to-validate-user-token.html"
                  // eslint-disable-next-line react/jsx-no-target-blank
                  target="_blank"
                >
                  验证 Token 文档。
                </a>
              </>,
            ],
          },
        ]}
      />
      <HomeTryOn
        tryOnBtn={
          <>
            <a
              href="https://vue-authing.authing.cn/"
              // eslint-disable-next-line react/jsx-no-target-blank
              target="_blank"
              className="try-now-link-btn"
            >
              立即使用
            </a>

            <span style={{ marginLeft: 30 }}>
              <Link
                target="_blank"
                href="https://docs.authing.cn/v2/quickstarts/spa/vue.html"
              >
                开发者文档
              </Link>
            </span>
          </>
        }
      />
      <div className="wechat-code-box">
        {showCode && (
          <div className="wechat-code-content">
            <div
              className="wechat-code-close"
              onClick={() => {
                setShowCode(!showCode);
              }}
            >
              <img
                src="//files.authing.co/authing-website/ad-wechat-close.png"
                alt="authing"
              />
            </div>
            <img
              src="//files.authing.co/authing-website/ad-wechat-code.png"
              alt="authing"
            />
            <div className="text">扫一扫进入技术交流群</div>
            <div className="text">不定期抽奖活动等你领</div>
          </div>
        )}
        {!showCode && (
          <div
            className="wechat-code-closed"
            onClick={() => {
              setShowCode(!showCode);
            }}
          >
            <img
              src="//files.authing.co/authing-website/ad-wechat-code-closed.png"
              alt="authing"
            />
          </div>
        )}
      </div>
    </div>
  );
};
